import {action} from 'mobx';

import {EXPIRE_TIME, EXPIRES_IN, EXPIRES_PENDING} from '../../../constants/storeConstants';
import {STATE_PENDING, STATE_FULFILLED, STATE_REJECTED} from '../../../constants/asyncConstants';
import serverApi from '../../../utils/serverApi';
import ApiMapBaseStore from '../common/apiMapBaseStore';

/**
 * ApiCompanyCreditsRenewalStore
 */
class ApiCompanyCreditsRenewalStore extends ApiMapBaseStore {
  /**
   * Fetches the download credits renewal information from the server.
   *
   * @param {string} companyId
   */
  @action makeRequest(companyId) {
    this.dataMap.set(companyId, {
      state: STATE_PENDING,
      [EXPIRE_TIME]: Date.now() + EXPIRES_PENDING,
      data: null,
      error: null,
    });

    serverApi.creditsRenewal(companyId).then(
      action('creditsRenewalSuccess', (creditsRenewal) => {
        this.dataMap.set(companyId, {
          state: STATE_FULFILLED,
          [EXPIRE_TIME]: Date.now() + EXPIRES_IN,
          data: creditsRenewal,
          error: null,
        });
      }),
      action('creditsRenewalError', (creditsRenewalError) => {
        this.dataMap.set(companyId, {
          state: STATE_REJECTED,
          [EXPIRE_TIME]: null,
          data: null,
          error: creditsRenewalError,
        });
      })
    );
  }
}

export default new ApiCompanyCreditsRenewalStore();
